import boat from "./Images/boat.png";
import zee5 from "./Images/Zee5.png";
import expedia from "./Images/expedia.png";
import mfh from "./Images/mfh.png";
import gwt from "./Images/gwt.png";
import sb from "./Images/sb.png";

export const Projectdata = [
  {
    id: 1,
    name: "boAt-lifeStyle.com Clone",
    image: boat,
    desc: "India's fastest growing audio & wearables brand. The most incredible range of wireless earphones, earbuds, headphones, smart watches, and home audio.",
    techStack: "HTML | CSS | Javascript | ReactJS | ChakraUI",
    livelink: "https://musicwarehouse.vercel.app/",
    gitlink: "https://github.com/SunilHooda/boAt-Lifestyle.com-Clone",
  },
  {
    id: 2,
    name: "ZEE5 OTT Platform Clone",
    image: zee5,
    desc: "ZEE5 is an Indian subscription video on-demand and over-the-top streaming service, run by Zee Entertainment Enterprises.",
    techStack: "HTML | CSS | Javascript | Bootstrap",
    livelink: "https://verdant-shortbread-516388.netlify.app/",
    gitlink: "https://github.com/somya143/chemical-rake-3857",
  },
  {
    id: 3,
    name: "Expedia.co.in Clone",
    image: expedia,
    desc: "Expedia is a web application, offering travellers an extensive selection of hotels, activities and travel services to meet every budget and activities of every kind at competitive rates with over hundreds of thousands of hotel partners worldwide.",
    techStack: "CSS | Javascript | ReactJS | Redux | ChakraUI",
    livelink: "https://expedia-clone-five.vercel.app/",
    gitlink: "https://github.com/Dhanraj4198/average-collar-3069",
  },
  {
    id: 4,
    name: "ikea.com Clone",
    image: mfh,
    desc: "ikea.com is an online e-commerce platform which deal in home funiture. Its products are almost everything which we use in our house like Furniture, Appliances, Kitchen Products, Storage products and spare parts for the same.",
    techStack:
      "CSS | Javascript | ReactJS | Redux | ChakraUI | NodeJS | Express | Mongoose | MongoDB",
    livelink: "https://mfh.vercel.app",
    gitlink: "https://github.com/tarunksao/melted-group-7444",
  },
  {
    id: 5,
    name: "Global Web Technology",
    image: gwt,
    desc: "This project was initially built using Angular and was transitioned to HTML, CSS, and JavaScript. It integrates Email.js and connects to Google Sheets using AppScript to store IP addresses for lead generation.",
    techStack:
      "HTML | CSS | Javascript | E-Mail js | Tailwind CSS | AppScript ",
    livelink: "https://globalwebtechnology.in",
    gitlink: "https://github.com/Asif-Wali/GWT-WebSite",
  },
  {
    id: 6,
    name: "Shop Bag",
    image: sb,
    desc: "ShopBag is a E-commerce website integrated with Stripe for secure payment processing. The website allows users to browse products, add items to their cart, and complete purchases using Stripe's seamless checkout system. ",
    techStack:
      "CSS | Javascript | ReactJS | Redux | Tailwind CSS | NodeJS | Express | Mongoose | MongoDB | Stripe ",
    livelink: "https://shopbagministore.vercel.app/",
    gitlink: "https://github.com/SunilHooda/ShopBag",
  },
];
